import React, { useEffect } from 'preact/compat';
import { Formik, Form, FormikHelpers, useFormikContext } from 'formik';
import { EmailFormValues, EmailFormProps } from './types';
import { EmailFormContext, useEmailFormContext } from './context';
import { initialValues, validationSchema } from '../../../lib/email';
import DepartmentFields from './department';
import MessageFields from './message';
import Submit from './submit';
import { useDialog } from '../../overlay/hooks';
import Dialog from '../../overlay/dialog';
import ConsumerContactRedirect from './redirect';
import RecaptchaField from '../recaptcha';

export default function EmailForm(props: EmailFormProps) {
    async function handleSubmit(values: EmailFormValues, { resetForm, setStatus }: FormikHelpers<EmailFormValues>) {
        const response = await fetch('/wp-json/mizkan/v1/enquiries/email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(values),
        });

        if (!response.ok) {
            console.error(await response.json());

            return;
        }

        resetForm();
        setStatus(true);
    }

    return (
        <EmailFormContext.Provider value={props}>
            <Formik
                initialValues={initialValues}
                initialStatus={false}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}>
                <Form noValidate={true} className='form'>
                    <DepartmentFields />
                    <ConsumerContactRedirect>
                        <MessageFields />
                        <div className='form__footer'>
                            <RecaptchaField name='recaptcha' />
                        </div>
                        <Submit />
                    </ConsumerContactRedirect>
                    <SuccessDialog />
                </Form>
            </Formik>
        </EmailFormContext.Provider>
    );
}

function SuccessDialog() {
    const { status } = useFormikContext();
    const [isDialogShown, showDialog, hideDialog] = useDialog();
    const {
        classNames: {
            button: {
                submit: buttonClassName,
            },
        },
    } = useEmailFormContext();

    useEffect(() => {
        if (status === true) {
            showDialog();
        } else {
            hideDialog();
        }
    }, [status]);

    return (
        <Dialog titleId='success-heading' shown={isDialogShown}>
            <Dialog.Heading id='success-heading'>
                Thank you!
            </Dialog.Heading>
            <div className='type  type--center'>
                <p>We have received your enquiry.</p>
                <p>One of our team will be in touch within 5 working days.</p>
                <p>We recommend keeping an eye on your junk mail box in case our reply goes in there.</p>
            </div>
            <Dialog.Footer>
                <a href='/' className={buttonClassName}>
                    Return to home
                </a>
            </Dialog.Footer>
        </Dialog>
    );
}
